import axios from 'axios';
import { apiServerHost } from '../../common/APIServerSettings';

const getGlobalEntityList = (callBackFunc, entityType) => {
  const params = new URLSearchParams();
  params.append('entityType', entityType)
  axios.get(apiServerHost + "/manage/topic/builder/get/globalEntityList", {
    params : params,
  })
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}
const getEntityList = (callBackFunc, topicID) => {
  const params = new URLSearchParams();
  params.append('topicID', topicID);
  axios.get(apiServerHost + "/manage/topic/builder/get/entityList", {
    params : params,
  })
  .catch( error => {
    alert("정보를 가져오지 못했습니다.");
    
  })
  .then( response => {
    callBackFunc(response);
  });
}
const getModuleList = (callBackFunc) => {
  axios.get(apiServerHost + "/manage/topic/builder/get/moduleList")
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}
const getAgentList = (callBackFunc) => {
  axios.get(apiServerHost + "/manage/topic/builder/get/agentList")
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}

export {getGlobalEntityList};
export {getEntityList};
export {getModuleList};
export {getAgentList};